import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { route } from 'preact-router';

import style from './style.css';

function isConsumerWeb(cat) {
    if (cat.showOnConsumerWeb) {
        return (
            <small>
                <span class='badge'>cw</span>
            </small>
        );
    }
    return '';
}

function isDealerWeb(cat) {
    if (cat.status === 2) {
        return (
            <small>
                <span class='badge'>dw</span>
            </small>
        );
    }
    return '';
}

const initialState = {};

@observer
class CategoryBranch extends Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };
    }

    render(props = this.props) {
        const { categoryStore } = props.stores;
        const { categoryTree, categoryView, queryFilter, toggleQueryfilter } = categoryStore;

        return (
            <div class='ml-4'>
                {categoryTree.map((cat) => {
                    const isSelectedMain = cat.groupno == queryFilter.parent;
                    const onClickMain = cat.children ? () => {
                        toggleQueryfilter('parent', cat.groupno, {
                            setValue: 1,
                            toggle: groupno => categoryStore.updateCategoryView(cat.groupno, groupno == cat.groupno ? 1 : null),
                        });
                        route(`/categories/`, true);
                    } : () => route(`/categories/${cat.groupno}/Basics`, true);
                    const editMain = (e) => {
                        e.stopPropagation();
                        route(`/categories/${cat.groupno}/Basics`, true);
                    };
                    const onClickRemoveMain = (e) => {
                        e.stopPropagation();
                        toggleQueryfilter('parent', '', { setValue: 1 });
                        categoryStore.updateCategoryView(cat.groupno, null);
                        route(`/categories/`, true);
                    };
                    const toggleMain = (e) => {
                        e.stopPropagation();
                        categoryStore.updateCategoryView(cat.groupno);
                    };
                    const hasChildrenMain = cat.children && cat.children.length > 0;
                    return (
                        <div class='nav-item'>
                            <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedMain ? 'active' : ''}`}>
                                <span onClick={onClickMain}>
                                    <nobr>
                                        <small>
                                            <i class={`fas fa-edit mr-1 text-${isSelectedMain ? 'light' : 'primary'} primary font-weight-lighter`} onClick={editMain} />
                                        </small>
                                        <i class={`${hasChildrenMain ? 'fas' : 'far'} fa-folder${categoryView[cat.groupno] ? '-open' : ''} mr-1`} onClick={toggleMain} />
                                        {cat.name} {cat.discount && <small class='font-weight-lighter'>{cat.discount}%</small>} {isConsumerWeb(cat)} {isDealerWeb(cat)}
                                    </nobr>
                                    {hasChildrenMain && <span class='font-weight-lighter float-right'>({cat.children.length})</span>}
                                </span>
                                {isSelectedMain && <span class={`${style.pointerCursor} float-right`}>
                                    <i class='fas fa-times-circle float-right mt-1' onClick={onClickRemoveMain} />
                                </span>}
                            </div>
                            <div class={`d-${categoryView[cat.groupno] ? 'block' : 'none'} nav flex-column mt-1`}>
                                {hasChildrenMain && cat.children.map((intcat) => {
                                    const isSelectedInt = intcat.groupno == queryFilter.parent;
                                    const onClickInt = intcat.children ? () => {
                                        toggleQueryfilter('parent', intcat.groupno, {
                                            setValue: 1,
                                            toggle: groupno => categoryStore.updateCategoryView(intcat.groupno, groupno == intcat.groupno ? 1 : null),
                                        });
                                        route(`/categories/`, true);
                                    } : () => route(`/categories/${intcat.groupno}/Basics`, true);
                                    const editInt = (e) => {
                                        e.stopPropagation();
                                        route(`/categories/${intcat.groupno}/Basics`, true);
                                    };
                                    const onClickRemoveInt = (e) => {
                                        e.stopPropagation();
                                        toggleQueryfilter('parent', '', { setValue: 1 });
                                        categoryStore.updateCategoryView(intcat.groupno, null);
                                        route(`/categories/`, true);
                                    };
                                    const toggleInt = (e) => {
                                        e.stopPropagation();
                                        categoryStore.updateCategoryView(intcat.groupno);
                                    };
                                    const hasChildrenInt = intcat.children && intcat.children.length > 0;
                                    return (
                                        <div class='ml-4'>
                                            <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedInt ? 'active' : ''}`}>
                                                {isSelectedInt && <span class={style.pointerCursor}>
                                                    <i class='fas fa-times-circle float-right mt-1' onClick={onClickRemoveInt} />
                                                </span>}
                                                <span onClick={onClickInt}>
                                                    <nobr>
                                                        <small>
                                                            <i class={`fas fa-edit mr-1 text-${isSelectedInt ? 'light' : 'primary'} font-weight-lighter`} onClick={editInt} />
                                                        </small>
                                                        <i class={`${hasChildrenInt ? 'fas' : 'far'} fa-folder${categoryView[intcat.groupno] ? '-open' : ''} mr-1`} onClick={toggleInt} />
                                                        {intcat.name} {intcat.discount && <small class='font-weight-lighter'>{intcat.discount}%</small>} {isConsumerWeb(intcat)} {isDealerWeb(intcat)}
                                                    </nobr>
                                                    {hasChildrenInt && <span class='font-weight-lighter float-right'>({intcat.children.length})</span>}
                                                </span>
                                            </div>
                                            <div class={`d-${categoryView[intcat.groupno] ? 'block' : 'none'} nav flex-column mt-1`}>
                                                {hasChildrenInt && intcat.children.map((subcat) => {
                                                    const isSelectedSub = subcat.groupno == queryFilter.parent;
                                                    const onClickSub = subcat.children ? () => {
                                                        toggleQueryfilter('parent', subcat.groupno, {
                                                            setValue: 1,
                                                            toggle: () => categoryStore.updateCategoryView(subcat.groupno, (!isSelectedInt && categoryView[subcat.groupno] ? 1 : null)),
                                                        });
                                                        route(`/categories/`, true);
                                                    } : () => route(`/categories/${subcat.groupno}/Basics`, true);
                                                    const editSub = (e) => {
                                                        e.stopPropagation();
                                                        route(`/categories/${subcat.groupno}/Basics`, true);
                                                    };
                                                    return (
                                                        <div class='ml-4'>
                                                            <div class={`${style.pointerCursor} nav-link py-0 ${isSelectedSub ? 'active' : ''}`}>
                                                                <span onClick={onClickSub}>
                                                                    <nobr>
                                                                        <small>
                                                                            <i class={`fas fa-edit mr-1 text-primary font-weight-lighter`} onClick={editSub} />
                                                                        </small>
                                                                        <i class={`far fa-folder${categoryView[subcat.groupno] ? '-open' : ''} mr-1`} />
                                                                        {subcat.name} {subcat.discount && <small class='font-weight-lighter'>{subcat.discount}%</small>} {isConsumerWeb(subcat)} {isDealerWeb(subcat)}
                                                                    </nobr>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default CategoryBranch;



// WEBPACK FOOTER //
// ./components/categories/treeBranch.js